$('#copy-address').click(function(e){
    e.preventDefault();

    $('#invoice_address_line_1').val($('#address_line_1').val());
    $('#invoice_address_line_2').val($('#address_line_2').val());
    $('#invoice_address_city').val($('#address_city').val());
    $('#invoice_address_postcode').val($('#address_postcode').val());
});
